import React from "react";
import "./Studio.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Kamar1images from "../../Media/Greenbay/Kamar1";
import Kamar2images from "../../Media/Greenbay/Kamar2";
import Kamar3images from "../../Media/Greenbay/Kamar3";
import Kamar4images from "../../Media/Greenbay/kamar4";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faCity,
  faDumbbell,
  faMedal,
  faN,
  faSwimmingPool,
} from "@fortawesome/free-solid-svg-icons";

import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

const ruko1 = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const Studio1Wa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283879132458&text=Halo%20Kak,%20Saya%20lihat%20iklan%20diwebsite,%20apa%20ada%20room%20available?%20https://sewa-apartemen-greenbay.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Studio2Wa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283879132458&text=Halo%20Kak,%20Saya%20lihat%20iklan%20diwebsite,%20apa%20ada%20room%20available?%20https://sewa-apartemen-greenbay.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Studio3Wa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283879132458&text=Halo%20Kak,%20Saya%20lihat%20iklan%20diwebsite,%20apa%20ada%20room%20available?%20https://sewa-apartemen-greenbay.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Studio4Wa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283879132458&text=Halo%20Kak,%20Saya%20lihat%20iklan%20diwebsite,%20apa%20ada%20room%20available?%20https://sewa-apartemen-greenbay.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="Studio" className="container">
      <div className="judulstudio">Our Studio Apartement</div>
      <div className="containercard-studio">
        <div className="card">
          <Slider {...settings}>
            {Kamar1images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-studio">
            <div className="nama-studio">Studio 1</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Fasilitas Lengkap</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faN} />
            <span> Netflix</span>
            <FontAwesomeIcon color="#334442" icon={faSwimmingPool} />
            <span> Swimming Pool</span>
            <FontAwesomeIcon color="#334442" icon={faDumbbell} />
            <span> Gym</span>
            <FontAwesomeIcon color="#334442" icon={faCity} />
            <span> City View</span>
          </div>
          <hr />

          <div className="clusterbutton">
            <button onClick={Studio1Wa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Kamar2images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-studio">
            <div className="nama-studio">Studio 2</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Fasilitas Lengkap</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faN} />
            <span> Netflix</span>
            <FontAwesomeIcon color="#334442" icon={faSwimmingPool} />
            <span> Swimming Pool</span>
            <FontAwesomeIcon color="#334442" icon={faDumbbell} />
            <span> Gym</span>
            <FontAwesomeIcon color="#334442" icon={faCity} />
            <span> City View</span>
          </div>
          <hr />

          <div className="clusterbutton">
            <button onClick={Studio2Wa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Kamar3images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-studio">
            <div className="nama-studio">Studio 3</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Fasilitas Lengkap</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faN} />
            <span> Netflix</span>
            <FontAwesomeIcon color="#334442" icon={faSwimmingPool} />
            <span> Swimming Pool</span>
            <FontAwesomeIcon color="#334442" icon={faDumbbell} />
            <span> Gym</span>
            <FontAwesomeIcon color="#334442" icon={faCity} />
            <span> City View</span>
          </div>
          <hr />

          <div className="clusterbutton">
            <button onClick={Studio3Wa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Kamar4images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-studio">
            <div className="nama-studio">Studio 4</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Fasilitas Lengkap</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faN} />
            <span> Netflix</span>
            <FontAwesomeIcon color="#334442" icon={faSwimmingPool} />
            <span> Swimming Pool</span>
            <FontAwesomeIcon color="#334442" icon={faDumbbell} />
            <span> Gym</span>
            <FontAwesomeIcon color="#334442" icon={faCity} />
            <span> City View</span>
          </div>
          <hr />

          <div className="clusterbutton">
            <button onClick={Studio4Wa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
      </div>

      <div></div>
    </div>
  );
};

export default ruko1;
